export const CUSTOMER_WIDGET_TOKEN_KEY = "redo.widget_auth_token";
export const OPEN_CUSTOMER_WIDGET_EVENT_KEY = "open_customer_widget";
export const CUSTOMER_WIDGET_ELEMENT_ID = "redo-chat-widget";
